import { codec, useUrlState } from './useUrlState'

const referenceSearchesCodec = {
    refColumnRosterIds: codec.stringArray(),
}

export function useReferenceSearchesUrlState() {
    const { state, setState } = useUrlState(referenceSearchesCodec)

    const refColumnRosterIds = state.refColumnRosterIds ?? []

    const setRefColumnRosterIds = (ids: string[]) =>
        setState({ refColumnRosterIds: ids })

    const addRosterId = (id: string) =>
        setState({ refColumnRosterIds: [...refColumnRosterIds, id] })

    const removeRosterId = (id: string) =>
        setState({
            refColumnRosterIds: refColumnRosterIds.filter((i) => i !== id),
        })

    return {
        refColumnRosterIds,
        setRefColumnRosterIds,
        addRosterId,
        removeRosterId,
    }
}
